<div class="row availability invalid-id-container">
  <div class="large-margin"></div>
  <div class="small-11 small-centered medium-6 large-5 columns text-center thank-you">
    <h5 class="non-cap">{{'gather.invalid-id.oops' | translate}}</h5>
    <div class="text">{{'gather.invalid-id.text' | translate}}</div>
  </div>
  <div class="small-11 small-centered medium-6 large-5 columns panel availability">
    <div class="see-more-jobs-container">
      <img alt="search icon" src="../../../assets/images/gather/see_more_jobs.png" class="material-icons large" />
      <div class="see-more-jobs-title">
        <h5>{{'gather.see-more-jobs' | translate}}</h5>
      </div>
      <div class="see-more-jobs-text">
        <span>{{'gather.see-more-jobs-text' | translate}}</span>
      </div>
      <button class="button expand primary interested" (click)="goToJobCenter()">{{'gather.visit-job-center' | translate}}</button>
    </div>
  </div>
</div>
